import React from "react";
import { SettingsServiceErrorCode } from "@sportal/api";

import { isSuccess, useLoadableSlice } from "../../store/shared";
import { getSettings } from "../../store/root.selectors";
import { getSettings as loadSettings } from "../../store/settings/settings.actions";
import { Logout } from "../../pages/login/Logout";
import ErrorPage, {
  shouldShowErrorPage,
} from "../../pages/errorPage/ErrorPage";

export const withSettingsGuard = (Component) => () => {
  const settings = useLoadableSlice(loadSettings(), getSettings);

  if (settings === null) {
    return null;
  }

  if (shouldShowErrorPage(settings, SettingsServiceErrorCode.GENERIC)) {
    return <ErrorPage />;
  }

  if (isSuccess(settings)) {
    return <Component />;
  }

  return <Logout />;
};
